// currency
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);



// Nav drawer open / close
const nd_section = document.getElementById("c-h-drawer-wrapper");

const navDrawerTl = gsap.timeline({ paused: true})
.to("#c-h-drawer", {x: 0, ease: "power1.out", duration: 0.4});

function ndOpen() {
  nd_section.style.display = "grid";
  navDrawerTl.play();
}

function ndClose() {
  navDrawerTl.reverse();
  setTimeout(() => {
    nd_section.style.display = "none";
  }, 400.0);
}

function ndSetOpenEvent() {
  document.querySelectorAll("[data-open-navdrawer]").forEach(function(trigger){
    trigger.addEventListener("click", function(){
      ndOpen();
    });
  });
}
ndSetOpenEvent();

function ndSetCloseEvent() {
  document.querySelectorAll("[data-close-navdrawer]").forEach(function(trigger){
    trigger.addEventListener("click", function(){
      ndClose();
    });
  });
}
ndSetCloseEvent();


// Shopify money formats
function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Debounce function
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


const cd_main = document.getElementById("cd-main");
const cd_cart_bubble = document.getElementById("cd-cart-bubble");
//const cd_cart_bubble = document.getElementById("cd-cart-count");
const cd_section = document.getElementById("cd-section");


// Update cart counter
function updateCounter(newData) {
  const cartCounter = parseInt(newData.item_count);
  if (cartCounter === 0 ) {
    cd_cart_bubble.style.display = "none";
    //cd_cart_bubble.innerHTML = "0";
  } else {
    cd_cart_bubble.innerHTML = cartCounter;
    cd_cart_bubble.style.display = "flex";
  }
}

// Change qty function
function changeItemQty(key, qty, button) {
  $.post("/cart/change.js", {
    id: key,
    quantity: qty
  })
  .then(response => {
    $.get("/?view=cart", (res) => {
      document.getElementById("cd-main").innerHTML = res;
      updateQty();
      removeQty();
      cdSetCloseEvent();
    });

    updateCounter(JSON.parse(response));
  });
}

function cdOpenCart() {
  upcartOpenCart();
}

document.querySelectorAll("[data-open-cart]").forEach(function(trigger){
  trigger.addEventListener("click", function(){
    upcartOpenCart();
  });
});
